// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin
// See configuration in webpack.config.js
import ErrorBanner from "./ErrorBanner-APP_CLIENT";

export default ErrorBanner;
